import Vue from 'vue'
import Vuex from 'vuex'
import check from './modules/check'
import getters from './getters'
import yxxnstate from './modules/yxxnstate'
import dqzs from './modules/dqzs'
import carbonApp from './modules/carbonApp'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    refreshPage: '',
    basicD: {},
    actives: Number,
    jscheckD: '',
    showFeedBack: true, // 是否显示意见反馈的组件
    feedBackPath: ['其它', '意见反馈'], // 意见反馈 页面的面包屑路径
    updatePage: false, // 意见反馈页面是否需要更新
    progressData: 0, // 进度条数据
    sourceData: null, // 取消上传
    subsidyData: false, // 首页刷新是弹出公告,
    noReadNum: [0, 0, 0], // 总未读，业务消息，公告消息
    isShowData: true, // 分享页面不显示意见反馈 公告弹窗
    carbonDetailsData: [], // 碳足迹计算器-计算详情列表
    allAmout: 0, // 碳足迹排碳总量
    addAmout: 0, // 碳足迹增量
    userStates: 'carbon-neutral-2021031801', // 碳账户信息
    menuInfo: '', // 碳账户菜单
    preWidth: [90, 110, 80, 60],
    provinceInfo: '',
    roluesId: ''
  },
  mutations: {
    // 碳足迹排碳新增量
    setPreWidth (state, val) {
      state.preWidth = val
    },
    // 碳足迹排碳新增量
    setAddAmout (state, val) {
      state.addAmout = val
    },
    // 碳足迹排碳总量
    setAllAmout (state, val) {
      state.allAmout = val
    },
    // 碳足迹计算器-计算详情列表
    setCarbonDetailsData (state, val) {
      state.carbonDetailsData = val
    },
    setRefreshPageVal (state, val) {
      state.refreshPage = val
    },
    applyBasic (state, val) {
      state.basicD = val
    },
    setStepsActive (state, v) {
      state.actives = v
    },
    setJscheckData (state, v) {
      state.jscheckD = v
    },
    SET_SHOW_FEED_BACK (state, val) {
      state.showFeedBack = val
    },
    SET_USER_STATES (state, val) {
      state.userStates = val
    },
    SET_MENU_INFO (state, val) {
      state.menuInfo = val
    },
    SET_PROVINCE_INFO (state, val) {
      state.provinceInfo = val
    },
    SET_Roles_Id (state, val) {
      state.roluesId = val
    },
    SET_FEED_BACK_PATH (state, val) {
      state.feedBackPath = val
    },
    SET_UPDATE_PAGE (state, val) {
      state.updatePage = val
    },
    SET_PROGRESS_DATA (state, val) {
      state.progressData = val
    },
    SET_SOURCE_DATA (state, val) {
      console.log(val,'rrrrrrrrrrrr')
      state.sourceData = val
    },
    SET_SUBSIDY_DATA (state, val) {
      state.subsidyData = val
    },
    SET_NOREADNEWS (state, val) {
      state.noReadNum = val
    },
    SET_ISSHOW_DATA (state, val) {
      console.log(val,'eee')
      state.isShowData = val
    }

  },
  actions: {
    // 碳足迹排碳增量
    setPreWidthData ({ commit }, info) {
      commit('setPreWidth', info)
    },
    // 碳足迹排碳增量
    setAddAmoutData ({ commit }, info) {
      commit('setAddAmout', info)
    },
    // 碳足迹排碳总量
    setAllAmoutData ({ commit }, info) {
      commit('setAllAmout', info)
    },
    // 碳足迹计算器-计算详情列表
    setCarbonDetails ({ commit }, info) {
      commit('setCarbonDetailsData', info)
    },
    setShowFeedBack ({ commit }, info) {
      commit('SET_SHOW_FEED_BACK', info)
    },
    setFeedBackPath ({ commit }, info) {
      commit('SET_FEED_BACK_PATH', info)
    },
    setUserState ({ commit }, info) {
      commit('SET_USER_STATES', info)
    },
    setMenuInfo ({ commit }, info) {
      commit('SET_MENU_INFO', info)
    },
    setRolesID ({ commit }, info) {
      commit('SET_Roles_Id', info)
    },
    setProvince ({ commit }, info) {
      commit('SET_PROVINCE_INFO', info)
    },
    setUpdatePage ({ commit }, info) {
      commit('SET_UPDATE_PAGE', info)
    },
    setProgressData ({ commit }, info) {
      commit('SET_PROGRESS_DATA', info)
    },
    setSourceData ({ commit }, info) {
      commit('SET_SOURCE_DATA', info)
    },
    GET_NEWCODEFLAGESTATUS({ commit, rootState }, params) {
      return new promise((resolve, reject) => {
        if (!params) {
          //当不传递值的情况下去点击资源模块取值
          let { id_, projectCode } = rootState.engineAPIevent.selectResource
          params = { checkedCode: [id_], projectCode: projectCode, isRecommended: 0 }
        }
        params && request.get(URL.GET_NEWCODE, { params: { ...params } }).then(res => {
          let { code, data } = res
          // code  200为新资源  400为老资源
          commit('POST_RESOURCESTATUS', code == '200' || !data ? false : data)
          resolve(code != '200' || !data ? false : data)
        }).catch(() => {
          reject(false)
        })
      })
    },
    setSubsidyData ({ commit }, info) {
      commit('SET_SUBSIDY_DATA', info)
    },
    setNoReadNum ({ commit }, info) {
      commit('SET_NOREADNEWS', info)
    },
    setIsshowData ({ commit }, info) {
      commit('SET_NOTICE', info)
    }
    ,
    setIsshowDataaaa ({ commit }, info) {
      commit('SET_NOTICEaaaaa', info)
    }
  },
  getters: {
    sourceData: state => state.sourceData,
  },
  modules: {
    check,
    getters,
    yxxnstate,
    dqzs,
    carbonApp
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js